export enum ENTITY {
	COMPANY = 'Company',
	GOOD = 'Good',
	BANNER = 'Banner',
	WIDGET = 'Widget',
	CANDIDACY = 'Candidacy',
	AWARD = 'Award',
	USER = 'User',
	EDITORIAL_SECTION = 'EditorialSection',
	RETAILER = 'Retailer',
	NEWS = 'News',
	TEAM = 'Team',
	EMAIL_DOMAIN = 'EmailDomain',
	FAIR_PARTICIPATION = 'FairParticipation',
	FAIR = 'Fair',
	GEO_INDICATION = 'GeoIndication',
	COMPANY_GROUP = 'CompanyGroup',
	HTML_TEMPLATE = 'HtmlTemplate',
	EU_CATEGORY = 'EuCategory',
	SERVICE = 'Service',
	NEWS_FORMAT = 'NewsFormat',
	EDITORIAL_TAG = 'EditorialTag',
	OBJECT_HISTORY = 'ObjectHistory',
	BRANCH = 'Branch',
	COMPANY_LEVEL = 'CompanyLevel',
	COMPANY_YEAR = 'CompanyYear',
	HIGHLIGHTED_GOOD = 'HighlightedGood',
	GOOD_FORMAT = 'GoodFormat',
	AWARD_CATEGORY = 'AwardCategory',
	AWARD_INVITED_USER = 'AwardInvitedUser',
	AWARD_INVITED_COMPANY = 'AwardInvitedCompany',
	COMPANY_CERTIFICATION = 'CompanyCertification',
	BRAND = 'Brand',
	AWARD_RESULT = 'AwardResult',
	GOOD_CLASS = 'GoodClass',
	MANAGED_BY_USER = 'ManagedByUser',
	GOOD_FEATURE_CERTIFICATION = 'GoodFeatureCertification',
	NEWS_CITATION = 'NewsCitation',
	CANDIDACY_RATING = 'CandidacyRating',
	TERMS_OF_SERVICE = 'ToS',
	QUESTION_SET = 'QuestionSet',
	ANSWER_SET = 'AnswerSet',
	// PERMALINK = 'Permalink',
	NEWSLETTER = 'Newsletter',
	// NEWSLETTER_ISSUE_HAS_NEWS = 'NewsletterIssue_has_News',
	NEWSLETTER_ISSUE = 'NewsletterIssue',
	// MAGAZINE_SUBSCRIPTION = 'MagazineSubscription',
	MAGAZINE = 'Magazine',
	MAGAZINE_COLLECTION = 'MagazineCollection',
	FREQUENT_SEARCH = 'FrequentSearch',
	STATE_PROVINCE = 'StateProvince',
	FAIR_VISIT = 'FairVisit',
	COMPANY_BADGE = 'CompanyBadge',
	DISTRIBUTION_CHANNEL = 'DistributionChannel',
	COUNTRY = 'Country',
	MEDIA = 'Media',
	// MAGAZINE_BRAND = 'MagazineBrand',
	MAGAZINE_CONTENT = 'MagazineContent',
	TYPEFORM = 'Typeform',
	FOOD_SERVICE = 'FoodService',
	COUPON = 'Coupon',
	DATA_VIZ = 'DataViz',
	GOOD_RECALL = 'GoodRecall',
	PLMANUFACTURER = 'PLManufacturer',
	STORECHAIN = 'StoreChain',
	COMPANY_360 = 'Company360',
	GOOD_360 = 'Good360',
	TREND_360 = 'Trend360',
	ADV = 'Adv',
	GOOD_CLAIM = 'GoodClaim',
	GOOD_360_EVIDENCE = 'Good360Evidence'
}
